import { useGetGraphqlDataQuery } from '@repo/services';
import { message } from '@repo/ui';
import { Select, Typography } from 'antd';
import { type DefaultOptionType } from 'antd/es/select';
import { dynamicFields } from 'email/data/dynamicFields';
import { getLeadAttributes } from 'email/queries/getLeadAttributes';
import { useEffect, useState } from 'react';

import styles from './DynamicFieldsSelect.module.scss';

export default function DynamicFieldsSelect({
  onDropdownVisibleChange,
  onChange,
}: {
  onDropdownVisibleChange?: ((open: boolean) => void);
  onChange?: ((value: any, option: DefaultOptionType | DefaultOptionType[]) => void);
}) {
  type BaseOptionsType = {
    value: string;
    label: string;
  };

  const [options, setOptions] = useState<BaseOptionsType[]>([]);

  const {
    data,
    isLoading: attributesLoading,
    error,
  } = useGetGraphqlDataQuery({ document: getLeadAttributes });

  useEffect(() => {
    if (error) {
      message.error('Failed to Load Attributes');
    }
  }, [error]);

  useEffect(() => {
    if (!attributesLoading && data) {
      setOptions(data?.leadAttributes || []);
    }
  }, [attributesLoading, data]);

  const selectOptions = [
    {
      label: (
        <Typography.Text className={styles.groupTitle} type="secondary">
          Lead Attributes
        </Typography.Text>
      ),
      title: 'Lead Attributes',
      options: options?.map(({ label, value }) => ({
        label: `Lead:${label}`,
        value: `Lead:${value}`,
      })) || [],
    },
    {
      label: (
        <Typography.Text className={styles.groupTitle} type="secondary">
          Owner Fields
        </Typography.Text>
      ),
      title: 'Owner Fields',
      options: dynamicFields.ownerFields.map(({ label, value }) => ({
        label: `Owner:${label}`,
        value: `Owner:${value}`,
      })),
    },
    {
      label: (
        <Typography.Text className={styles.groupTitle} type="secondary">
          Sender Fields
        </Typography.Text>
      ),
      title: 'Sender Fields',
      options: dynamicFields.ownerFields.map(({ label, value }) => ({
        label: `Sender:${label}`,
        value: `Sender:${value}`,
      })),
    },
  ];

  return (
    <Select
      showSearch
      placeholder="Add mail merge fields"
      onDropdownVisibleChange={onDropdownVisibleChange}
      options={selectOptions}
      onChange={onChange}
    />
  );
}
